import { JSX, useEffect, useState } from 'react';
import { translations } from '../../../configs/translations';
import { useStore } from '../../../store/store';

export interface VinylInformationCardProps {
    title: string;
    isEquipped?: boolean;
    handleEquip?: () => void;
    handleCreate?: (mode: string) => void;
    handleEdit?: (mode: string) => void;
}

export const VinylInformationCard = (props: VinylInformationCardProps) => {
    const language = useStore(state => state.language);
    const t = translations[language];

    const getButton = () => {
        if (props.handleCreate) {
            return (
                <div 
                    className='tuning-button tuning-buy-button' 
                    onClick={() => props.handleCreate?.('create')}
                >
                    <p>{t.create_vinyl}</p>
                </div>
            )
        } else if (props.handleEdit) {
            // return (
            //     <div 
            //         className='tuning-button tuning-buy-button' 
            //         onClick={() => props.handleEdit?.('edit')}
            //     >
            //         <p>{t.edit_vinyl}</p>
            //     </div>
            // )
        }
    }

    const getFooterButton = () => {
        if (props.handleCreate) return

        return (
            <div 
                className={`tuning-button tuning-equip-button ${props.isEquipped ? 'equipped' : ''}`} 
                onClick={
                    () => {
                        props.handleEquip?.(); 
                    }
                }
            >
                {props.isEquipped ? <img className="equipped-icon" src="../icons/checked.png" alt="checked" /> : <p>{t.equip}</p>}
            </div>  
        )
    }

    return (
        <div className='tuning-information-card'>
            <div className='tuning-information-card-header'>
                <h1>{props.title}</h1>
            </div>

            <div className='tuning-information-card-content'>
                <div className='content-block' key={999}/>
                
                <div className='tuning-information-card-footer'>
                    {getButton()}
                    {getFooterButton()}
                </div>
            </div>
        </div>
    )
}